import { CredentialIssuer, CredentialType } from '../Tester/types';

export const TYPE_CAN_BE_DEFAULT: CredentialType[] = ['BACKFLOW'];

export const ISSUER_CAN_HAVE_CITY: CredentialIssuer[] = [
  'CITY',
  'WATER_SUPPLIER',
];

export const ISSUER_REQUIRES_CITY: CredentialIssuer[] = ['CITY'];

export const ISSUER_CAN_HAVE_STATE: CredentialIssuer[] = [
  'STATE',
  'CITY',
  'COUNTY',
  'WATER_SUPPLIER',
];

export const ISSUER_REQUIRES_STATE: CredentialIssuer[] = ISSUER_CAN_HAVE_STATE;
